export default __webpack_public_path__ + "static/media/amazon-circle.0f5ee905.svg";